export const GRID_AREA_DIVIDER = 'divider';
